/* @ts-nocheck */
/* eslint-disable */
/* @noformat */
/* @formatter:off */
/**
* Generated by ng-openapi
* Generated Angular service for AuthenticationCtl controller
* Do not edit this file manually
*/
import { HttpClient, HttpContext, HttpContextToken, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { BASE_PATH_VERSUSCLIENT, CLIENT_CONTEXT_TOKEN_VERSUSCLIENT } from "../tokens";
import { HttpParamsBuilder } from "../utils/http-params-builder";
import { LoginDto, RequestOptions, LoginResponse, ChangePasswdDto } from "../models";

@Injectable({ providedIn: "root" })
export class AuthenticationCtlService {
    private readonly httpClient: HttpClient = inject(HttpClient);
    private readonly basePath: string = inject(BASE_PATH_VERSUSCLIENT);
    private readonly clientContextToken: HttpContextToken<string> = CLIENT_CONTEXT_TOKEN_VERSUSCLIENT;

    private createContextWithClientId(existingContext?: HttpContext): HttpContext {
        const context = existingContext || new HttpContext();
        return context.set(this.clientContextToken, 'VersusClient');
    }

    login(loginDto: LoginDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<LoginResponse>;
    login(loginDto: LoginDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<LoginResponse>>;
    login(loginDto: LoginDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<LoginResponse>>;
    login(loginDto: LoginDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/authentication/login`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('post', url, {
            body: loginDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    resetPassword(username: string, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    resetPassword(username: string, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    resetPassword(username: string, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    resetPassword(username: string, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/authentication/reset-password`;

        let params = new HttpParams();
        if (username != null) {
            params = HttpParamsBuilder.addToHttpParams(params, username, 'username');
        }

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }

        return this.httpClient.request('patch', url, {
            body: null,
            observe,
            headers,
            params,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }

    changePassword(changePasswdDto: ChangePasswdDto, observe?: 'body', options?: RequestOptions<'json'>): Observable<any>;
    changePassword(changePasswdDto: ChangePasswdDto, observe?: 'response', options?: RequestOptions<'json'>): Observable<HttpResponse<any>>;
    changePassword(changePasswdDto: ChangePasswdDto, observe?: 'events', options?: RequestOptions<'json'>): Observable<HttpEvent<any>>;
    changePassword(changePasswdDto: ChangePasswdDto, observe?: 'body' | 'events' | 'response', options?: RequestOptions<'arraybuffer' | 'blob' | 'json' | 'text'>): Observable<any> {
        const url = `${this.basePath}/authentication/change-password`;

        let headers: HttpHeaders;
        if (options?.headers instanceof HttpHeaders) {
            headers = options.headers;
        } else {
            headers = new HttpHeaders(options?.headers);
        }
        // Set Content-Type for JSON requests if not already set
        if (!headers.has('Content-Type')) {
            headers = headers.set('Content-Type', 'application/json');
        }

        return this.httpClient.request('patch', url, {
            body: changePasswdDto,
            observe,
            headers,
            reportProgress: options?.reportProgress,
            withCredentials: options?.withCredentials,
            context: this.createContextWithClientId(options?.context)
        });
    }
}
